<template>
  <div class="page5 content" style="width:100%;">
    <el-row style="height: 4vh; padding-left: 0.5vw; padding-top: 0.1vh;">
      <el-col :span="24" style="margin:0;">
        <div class="grid-content1 bg-purple-dark">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>绿色施工</el-breadcrumb-item>
            <el-breadcrumb-item>扬尘监测</el-breadcrumb-item>
          </el-breadcrumb>
          <div>
            <el-button type="warning" size="mini" @click="handleEdit">参数配置</el-button>
            <el-button type="primary" size="mini" @click="goDetail">历史数据统计</el-button>
          </div>
          
        </div>
      </el-col>
    </el-row>
    <!-- 主体 -->
    <el-container style="height:calc(100% - 4vh);width:100%;position: relative;flex-direction: column;">
      <div class="main-top">
        <div class="section-left">
           <div class="weather-date">
             <div style="display: flex;align-items: center;"><span class="circle"></span><p style="font-size: 1.1vw">实时天气</p></div>
             <div>{{time}}</div>
           </div>
           <div class="weather">
              <img :src="weather.now1" style="width: 8vw;"/>
           </div>
           <div class="temperature">
             <p style="font-size: 1.2vw;">{{weather.now3}}</p>
             <p style="font-size: 1.2vw;">{{weather.now2}}</p>
           </div>
        </div>
        <div class="section-center">
          <div class="equipmet-top">
             <div style="display: flex;align-items: center;"><span class="circle"></span><p style="font-size: 1.1vw">设备实时信息</p></div>
             <div style="color: #3C81F3;">3分钟前更新</div>
          </div>
          <div class="equipmet-body">
            <div class="equipmet-left">
                <div class="equipmet-item">
                  <div>设备总数</div>
                  <div style="margin-top: 1vh;color: #0263FF">{{dustTotal}}</div>
                </div>
                <div class="equipmet-item">
                  <div>在线设备</div>
                  <div style="margin-top: 1vh;color: #10BED1">{{dust.onlineDust}}</div>
                </div>
                <div class="equipmet-item">
                  <div>报警设备</div>
                  <div style="margin-top: 1vh;color: #D81E06">{{dust.alarmDust}}</div>
                </div>
                <div class="equipmet-item">
                  <div>离线设备</div>
                  <div style="margin-top: 1vh;color: #959595">{{dust.offlineDust}}</div>
                </div>
            </div>
            <div class="equipmet-right">
              <div ref="chart1" :style="{ height: '300px',width:'100%' }"></div>
            </div>
          </div>
        </div>
        <div class="section-right">
          <div style="display: flex;align-items: center;"><span class="circle"></span><p style="font-size: 1.1vw">设备列表</p></div>
            <el-table :data="dustList" border :show-header="false" height="28vh" style="margin-top: 2vh;" @row-click="changeDust">
              <el-table-column>
                <template slot-scope="scope">
                  <span>{{ scope.row.description }}</span>
                </template>
              </el-table-column>
              <el-table-column>
                <template slot-scope="scope">
                 <span>{{ scope.row.sn }}</span>
                </template>
              </el-table-column>
              <el-table-column>
                <template slot-scope="scope">
                   <span v-if="scope.row.min <= 15" style="color: green;">在线</span>
                   <span v-if="scope.row.min > 15" style="color: red;">离线</span>
                </template>
              </el-table-column>
            </el-table>
        </div>
      </div>
      <div class="main-bottom">
        <div class="monitor-left">
           <div style="display: flex;align-items: center;"><span class="circle"></span><p style="font-size: 1.1vw">实时数据监测</p></div>
             <div ref="chart2" :style="{ height: '400px',width:'90%' }"></div>
        </div>
        <div class="monitor-right">
          <div style="color: #3C81F3;text-align: right;margin-right: 1vw;">3分钟前更新</div>
          <div style="position: absolute;right: 1vw;">
            <div class="monitor-item">PM2.5：
              <span v-if="valData[0].val1 > normalDate.pm2" style="color: red;">污染</span>
              <span v-else>正常</span>
            </div>
            <div class="monitor-item">PM10：
              <span v-if="valData[0].val2 > normalDate.pm10" style="color: red;">污染</span>
              <span v-else>正常</span>
            </div>
            <div class="monitor-item">TSP：
              <span>{{valData[0].val3}}</span>
            </div>
            <div class="monitor-item">温度：
              <span v-if="valData[1].val1 > normalDate.temperature" style="color: red">不正常</span>
              <span v-else>正常</span>
            </div>
            <div class="monitor-item">湿度：
               <span v-if="valData[1].val2 > normalDate.humidity" style="color: red">不正常</span>
              <span v-else>正常</span>
            </div>
            <div class="monitor-item">噪音：
              <span v-if="valData[1].val3 > normalDate.noise" style="color: red">超标</span>
              <span v-else>正常</span>
            </div>
            <div class="monitor-item">风速：
              <span v-if="valData[2].val1 > normalDate.windSpeed" style="color: red">不正常</span>
              <span v-else>正常</span>
            </div>
            <div class="monitor-item">气压：{{valData[2].val3}}</div>
          </div>
        </div>
      </div>
    </el-container>
    <!-- 维护标准窗口 -->
    <el-dialog
        title="参数配置"
        :visible.sync="editFormVisible"
        center
        :append-to-body="true"
        :lock-scroll="false"
        custom-class='tower-dig'
        class="add-form"
        width="60%"
    >
      <div class="config-con">
        <p class="config-con-item" v-for="(item,index) in configList" :key="index">
          <span style="display: inline-block;width: 6vw;">{{item.name}}</span>
          <span style="display: inline-block;width: 10vw;">单位：（{{item.unit}}）</span>
          <span style="display: inline-block;width: 16vw;">设备预警限位：<el-input v-model="item.val" placeholder="请输入" style="width:5vw;"></el-input> {{item.unit}}</span>
        </p>
      </div>
      <div slot="footer" class="dialog-footer" style="">
          <el-button @click="editFormVisible = false">取 消</el-button>
          <el-button type="primary" @click="sumbitEditRow">确 定</el-button>
          <el-button type="info" @click="setDetfaule">恢复默认值</el-button>
      </div>
    </el-dialog>
    <!-- 维护PM2.5 优良差窗口 -->
    <el-dialog
        title="PM2.5配置"
        :visible.sync="pm2FormVisible"
        center
        :append-to-body="true"
        :lock-scroll="false"
        custom-class='tower-dig'
        class="add-form"
        width="60%"
    >
      <div class="config-con">
        <p class="config-con-item" v-for="(item,index) in pm2List" :key="index">
          <span style="display: inline-block;width: 6vw;">{{item.name}}</span>
          <span style="display: inline-block;width: 10vw;">单位：（{{item.unit}}）</span>
          <span style="display: inline-block;width: 16vw;">{{item.name1}}：<el-input v-model="item.val" placeholder="请输入" style="width:5vw;"></el-input> {{item.unit}}</span>
        </p>
      </div>
      <div slot="footer" class="dialog-footer" style="">
          <el-button @click="pm2FormVisible = false">取 消</el-button>
          <el-button type="primary" @click="sumbitEditRow">确 定</el-button>
          <el-button type="info" @click="setDetfaulePm2">恢复默认值</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import echarts from 'echarts' //引入echarts
import myHttp from '../../untils/port'
import util from '../../untils/util'
import base from '../../untils/base'

export default {
  name: 'eCharts',
  data() {
    return {
      myChart1: '',
      myChart2: '',
      alarmDust: 0,
      dustTotal: 0,
      dust: {
         alarmDust: 0,  // 报警设备
         onlineDust: 0,  //在线设备
         offlineDust: 0,  //离线设备
      },
      dustList:[],
      dustId:'',//当前设备id
      normalDate: {     // 正常数据，超出预警
        pm2Switch: 1,
        pm2: '',
        pm10Switch: 1,
        pm10: '',
        tsp: '',
        temperatureSwitch: 1,
        temperature: '',
        humiditySwitch: 1,
        humidity: '',
        noiseSwitch: 1,
        noise: '',
        windSpeedSwitch: 1,
        windSpeed: '',

      },   


      weather:{  //天气
        now1:require('../../assets/image/weather/w0.png'),
        now2:'7° ~ 16°',
        now3:'晴天',
      },
      allPart: {}, // 项目设备数组
      weekstart:'',
      weekEnd:'',
      time: util.myTime.formatTime(new Date(),'yyyy-MM-dd'),
      month: new Date().getMonth() + 1,
      year: new Date().getFullYear(),
      groupId: '',
      isDust: false,
      //配置弹出框
      editFormVisible: false, // 弹出框是否显示
      configList:[
        {name:'PM2.5',unit:'μg/m³',val:'75',status:true,default:'75'},
        {name:'PM10',unit:'μg/m³',val:'150',status:true,default:'150'},
        {name:'噪音',unit:'dB',val:'70',status:true,default:'70'},
        {name:'温度',unit:'℃',val:'0',status:true,default:'35'},
        {name:'湿度',unit:'%',val:'0',status:true,default:'60'},
        {name:'风速',unit:'m/s',val:'0',status:true,default:'8'},
      ],
      configData:{
        id:'',
        projectId:'',
        projectName:'',
        noiseSwitch:'1',  //噪音开关   1开  2关
        noise:70,        //噪音
        pm2Switch:'1',    //PM2.5开关   1开  2关
        pm2:'75',          //PM2.5
        pm10Switch:'1',   //PM10开关
        pm10:'150',         //pm10
        temperatureSwitch:'1',  //温度开关
        temperature:0,  //温度
        humiditySwitch:'1',  // 湿度开关
        humidity:0,     //湿度
        windSpeedSwitch:'1', //风速开关
        windSpeed:0,    //风速
        createBy:'1',
        pm25:'',
      },
      hasConf:false,//判断是否已经有配置
      projectName:'',

      warnVal:{pm2Warning:75,pm10Warning:150,noiseWarning:70,temperatureWarning:0,humidityWarning:0,windSpeedWarning:0},
      pm2FormVisible:false,
      pm2List:[
         {name:'PM2.5',unit:'μg/m³',name1:'优',val:'100',status:true,default:'100'},
         {name:'PM2.5',unit:'μg/m³',name1:'良',val:'200',status:true,default:'200'},
      ],
      //数据展示
      valData:[
        {name1:'PM2.5',val1:'',name2:'PM10',val2:'',name3:'TSP',val3:''},
        {name1:'温度',val1:'',name2:'湿度',val2:'',name3:'噪音',val3:''},
        {name1:'风速',val1:'',name2:'风向',val2:'',name3:'气压',val3:''}
      ],

      // 图表数据展示   --  新
      newValData: [],
      //预警
      warn:{
        icon:require('../../assets/image/icon/warn.png'),
        list:[]
      },
      //定时器
      timeOutFun:undefined,
    }
  },
  filters: {
    formatDate(value) {
      let date = new Date(value)
      let y = date.getFullYear()
      let MM = date.getMonth() + 1
      MM = MM < 10 ? '0' + MM : MM
      let d = date.getDate()
      d = d < 10 ? '0' + d : d
      let h = date.getHours()
      h = h < 10 ? '0' + h : h
      let m = date.getMinutes()
      m = m < 10 ? '0' + m : m
      let s = date.getSeconds()
      s = s < 10 ? '0' + s : s
      return y + '-' + MM + '-' + d + ' ' + h + ':' + m
    }
  },
  watch: {
    year: {
      handler(newVal) {
        this.getDataLine()
      },
      deep: true
    },
    month: {
      handler(newVal) {
        this.getDataLine()
      },
      deep: true
    }
  },
  mounted() {
    this.myChart1 = this.$echarts.init(this.$refs.chart1);
    this.myChart2 = this.$echarts.init(this.$refs.chart2);
    if (util.session.get('roleId') != '4') {
      this.groupId = util.session.get('proId')
    } else {
      this.groupId = util.session.get('groupId')
    }
    if (this.$route.name == 'dustPro') {
      this.isDust = true
    } else {
      this.isDust = false
    }
    var curWeek = util.myTime.getCurWeek()
    this.weekstart = curWeek[0]
    this.weekEnd = curWeek[1]
    this.getProjectById()
    this.getList()
    this.getConfigForWarn()
  },
  methods: {
    // 获取设备列表
    getList(){
      myHttp.getListByProjectIdList({
        projectId: this.groupId
      }).then(resp => {
        console.log(resp);
        if(resp.data.code == '200'){
          const dustList = resp.data.data.dustList || []
          let onlineDust = 0
          let offlineDust = 0
          for(let i=0; i<dustList.length;i++){
            if(dustList[i].min <= 15){
              onlineDust++
            }else{
              offlineDust++
            }
          }
          this.dustList = dustList
          this.dustTotal = dustList.length  // 设备总数
          this.dust.onlineDust = onlineDust  //在线设备
          this.dust.offlineDust = offlineDust  // 离线设备
          this.dustId = this.dustList[0].sn
          util.session.set('dustId', this.dustList[0].sn)
          this.getData()
        }else{
          this.$message.error(resp.data.msg)
        }
      })
    },
    // 点击表格选择设备
    changeDust(row, column, event){
      util.session.set('dustId', row.sn)
      this.dust.alarmDust = 0
      this.dustId = row.sn
      this.getData()
    },
    // 获取预警
    getConfigForWarn(){
      myHttp.selectDustConfig({
        projectId:util.session.get('groupId')
      }).then(resp => {
        console.log(resp);
         if(resp.data.code == '200'){
           this.normalDate = resp.data.data.list
         }else{
           this.$message.error(resp.data.msg)
         }
      })
    },
    // for循环获取其他设备的信息，已获得最终报警设备
    getDataOther(){
      for(let i =1;i<this.dustList.length; i++){
         myHttp.getCurDustInfo({
            projectId:this.groupId,
            id:this.dustList[i].sn
          }).then(resp => {
            if(resp.data.code=='200'){
              let data = resp.data.data.dust || []

              let flag = false
              if(this.normalDate.pm2Switch == 1){
                if(data.pm2 > this.normalDate.pm2){
                  flag = true
                }
              }
              if(this.normalDate.pm10Switch == 1){
                if(data.pm10 > this.normalDate.pm10){
                  flag = true
                }
              }
              if(this.normalDate.temperatureSwitch == 1){
                if(data.temperature > this.normalDate.temperature){
                  flag = true
                }
              }
              if(this.normalDate.humiditySwitch == 1){
                if(data.humidity > this.normalDate.humidity){
                  flag = true
                }
              }
              if(this.normalDate.noiseSwitch == 1){
                if(data.noise > this.normalDate.noise){
                  flag = true
                }
              }
              if(this.normalDate.windSpeedSwitch == 1){
                if(data.windSpeed > this.normalDate.windSpeed){
                  flag = true
                }
              }
              if(flag){
                this.dust.alarmDust++
              }
              this.initCharts1()
              
              }
        })
      }
    },




    // 获取数据
    getData() {
      // 扬尘检测
      let that = this
      myHttp.getCurDustInfo({
        projectId:this.groupId,
        id:this.dustId
      }).then(resp => {
        if(resp.data.code=='200'){
          let data = resp.data.data.dust || []
          console.log(data);
          // data.pm2BL = data.pm2 && data.pm2!=''?parseFloat(data.pm2)/250*100:0
          // data.pm2BL = data.pm2BL>100?100:data.pm2BL
          // data.pm10BL = data.pm10 && data.pm10!=''?parseFloat(data.pm10)/300*100:0
          // data.pm10BL = data.pm10BL>100?100:data.pm10BL
          // data.noiseBL = data.noise && data.noise!=''?parseFloat(data.noise)/120*100:0
          // data.noiseBL = data.noiseBL>100?100:data.noiseBL

          /*  {name1:'PM2.5',val1:'',name2:'PM10',val2:'',name3:'TSP',val3:''},
        {name1:'温度',val1:'',name2:'湿度',val2:'',name3:'噪音',val3:''},
        {name1:'风速',val1:'',name2:'风向',val2:'',name3:'气压',val3:''} */
       /*  pm2Switch: 1,
        pm2: '',
        pm10Switch: 1,
        pm10: '',
        tsp: '',
        temperatureSwitch: 1,
        temperature: '',
        humiditySwitch: 1,
        humidity: '',
        noiseSwitch: 1,
        noise: '',
        windSpeedSwitch: 1,
        windSpeed: '', */
        let flag = false
        if(this.normalDate.pm2Switch == 1){
          if(data.pm2 > this.normalDate.pm2){
            flag = true
          }
        }
        if(this.normalDate.pm10Switch == 1){
          if(data.pm10 > this.normalDate.pm10){
            flag = true
          }
        }
        if(this.normalDate.temperatureSwitch == 1){
          if(data.temperature > this.normalDate.temperature){
            flag = true
          }
        }
        if(this.normalDate.humiditySwitch == 1){
          if(data.humidity > this.normalDate.humidity){
            flag = true
          }
        }
        if(this.normalDate.noiseSwitch == 1){
          if(data.noise > this.normalDate.noise){
            flag = true
          }
        }
        if(this.normalDate.windSpeedSwitch == 1){
          if(data.windSpeed > this.normalDate.windSpeed){
            flag = true
          }
        }
        if(flag){
          console.log(this.dust.alarmDust);
          this.dust.alarmDust++
        }
        // if(this.normalDate.pm2Switch == 1){
        //   if(data.pm2 > this.normalDate.pm2){
        //     flag = true
        //   }
        // }
        // if(this.normalDate.pm2Switch == 1){
        //   if(data.pm2 > this.normalDate.pm2){
        //     flag = true
        //   }
        // }
          that.valData[0].val1 = data.pm2
          that.valData[0].val2 = data.pm10
          that.valData[0].val3 = data.tspCode
          that.valData[1].val1 = data.temperature
          that.valData[1].val2 = data.humidity
          that.valData[1].val3 = data.noise
          that.valData[2].val1 = data.windSpeed
          that.valData[2].val3 = data.pressureCode
          that.newValData = [
            data.pm2?parseFloat(data.pm2):0,data.pm10?parseFloat(data.pm10):0,data.tspCodedata?parseFloat(data.tspCodedata):0,data.temperatur?parseFloat(data.temperatur):0,
            data.humidity?parseFloat(data.humidity):0,data.noise?parseFloat(data.noise):0, data.windSpeed?parseFloat(data.windSpeed):0,data.pressureCode?parseFloat(data.pressureCode):0
          ]
          that.allPart = data
          that.getDataOther()
        }
        if(that.timeOutFun){
          window.clearTimeout(that.timeOutFun)
        }
        that.timeOutFun = setTimeout(()=>{
          that.dust.alarmDust = 0
          that.getData()
        },30000)
        that.initCharts2()
      })
    },
    
    //展示预警
    // getConfigForWarn(){
    //   var that = this
    //   myHttp.selectDustConfig({
    //     projectId:util.session.get('groupId')
    //   }).then(function(resp){
    //     console.log(resp);
    //     if(resp.data.code=='200'){
    //       var data = resp.data.data.list
    //       if(data){
    //         var list = []
    //         var icon = require('../../assets/image/icon/warn.png')
    //         that.warn.list = []
    //         for(var i=0;i<that.configList.length;i++){
    //           if(i==0){
    //             if(parseFloat(that.allPart.pm2)>parseFloat(data.pm2)){
    //               icon = require('../../assets/image/icon/warning.gif')
    //               list.push('PM2.5')
    //             }
    //           }else if(i==1){
    //             if(parseFloat(that.allPart.pm10)>parseFloat(data.pm10)){
    //               icon = require('../../assets/image/icon/warning.gif')
    //               list.push('PM10')
    //             }
    //           }else if(i==2){
    //             if(parseFloat(that.allPart.noise)>parseFloat(data.noise)){
    //               icon = require('../../assets/image/icon/warning.gif')
    //               list.push('噪音')
    //             }
    //           }else if(i==3){
    //             if(parseFloat(that.allPart.temperature)>parseFloat(data.temperature)){
    //               icon = require('../../assets/image/icon/warning.gif')
    //               list.push('温度')
    //             }
    //           }else if(i==4){
    //             if(parseFloat(that.allPart.humidity)>parseFloat(data.humidity)){
    //               icon = require('../../assets/image/icon/warning.gif')
    //               list.push('湿度')
    //             }
    //           }else if(i==5){
    //             if(parseFloat(that.allPart.windSpeed)>parseFloat(data.windSpeed)){
    //               icon = require('../../assets/image/icon/warning.gif')
    //               list.push('速度')
    //             }
    //           }
    //         }
    //         that.warn.icon = icon
    //         that.warn.list = list
    //       }
    //     }else{
    //       that.$message.error(resp.data.msg)
    //     }
    //   })
    // },

    //获取信息
    getProjectInfo(){
      var that = this
      myHttp.getProjectById({
        id:util.session.get('groupId')
      }).then(function(resp){
        if(resp.data.code=='200'){
          that.projectName = resp.data.data.project.name
        }
      })
    },

    /**
     * 获取预警
     */
    // getYijing(){
    //   var that = this
    //   myHttp.selectDustConfig({
    //     projectId:util.session.get('groupId')
    //   }).then(function(resp){
    //     if(resp.data.code=='200'){
    //       var data = resp.data.data
    //       if(data){
    //         // that.hasConf = true
    //         // that.configData = data
    //         // that.setConfigList(data)
    //       }else{
    //         // that.hasConf = false
    //       }
    //     }else{
    //       that.$message.error(resp.data.msg)
    //     }
    //   })
    // },
      


    // 扬尘检测  eChart4
    setChart4(data) {
      var option = {
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b}: {c} ({d}%)'
        },
        graphic: {
          type: 'text',
          left: 'center',
          top: 'center',
          z: 2,
          style: {
            text: data.all + '天',
            x: 100,
            y: 100,
            textAlign: 'center',
            fill: '#1B3BF5',
            height: 30,
            fontSize: 22,
            fontWeight: 'bold'
          }
        },
        legend: {
          orient: 'vertical',
          x: 'right',
          data: ['优', '良', '轻度']
        },
        series: [
          {
            name: '环境监测',
            type: 'pie',
            radius: ['55%', '75%'],
            hoverAnimation: false,
            itemStyle: {
              normal: {
                color: function(params) {
                  var colorList = ['#6CA2F4', '#78DD7A', '#C3C423']
                  return colorList[params.dataIndex]
                }
              }
            },
            avoidLabelOverlap: false,
            label: {
              normal: {
                show: false
              }
            },
            labelLine: {
              show: false
            },
            data: [
              { value: data.you, name: '优' },
              { value: data.liang, name: '良' },
              { value: data.cha, name: '轻度' }
            ]
          }
        ]
      }
      var page = this.$echarts.init(document.getElementById('page5Chart4'))
      page.setOption(option)
    },
    goDetail(){
      this.$router.push({name:'towerCraneData'})
    },
    //监听周时间
    getWeekFun(data,val){
      console.log(data)
      console.log(val)
    },
    //获取上周时间
    preWeek(){
       var date= util.myTime.getPrevWeek(this.weekstart)
       this.weekstart = date[0]
       this.weekEnd = date[1]
       this.getDataLine()
    },
    //获取下周时间
    nextWeek(){
      var date= util.myTime.getNextWeek(this.weekEnd)
       this.weekstart = date[0]
       this.weekEnd = date[1]
       this.getDataLine()
    },

    // 维护标准
    handleEdit(index, row) {
      this.dialogTitle = '参数配置'
      this.editFormVisible = true
      this.configData.projectId = util.session.get('groupId')
      this.configData.projectName = this.projectName
      var that = this
      myHttp.selectDustConfig({
        projectId:util.session.get('groupId')
      }).then(function(resp){
        if(resp.data.code=='200'){
          var data = resp.data.data.list
          if(data){
            that.hasConf = true
            that.configData = data
            that.setConfigList(data)
          }else{
            that.hasConf = false
          }
        }else{
          that.$message.error(resp.data.msg)
        }
      })
    },

    //插入数据
    setConfigList(data){
      for(var i=0;i<this.configList.length;i++){
        if(i==0){
          this.configList[i].val = data.pm2
        }else if(i==1){
          this.configList[i].val = data.pm10
        }else if(i==2){
          this.configList[i].val = data.noise
        }else if(i==3){
          this.configList[i].val = data.temperature
        }else if(i==4){
          this.configList[i].val = data.humidity
        }else if(i==5){
          this.configList[i].val = data.windSpeed
        }
      }
      if(data.pm25 && data.pm25!=''){
        var val1 = data.pm25.split(',')
        this.pm2List[0].val = val1[0]
        this.pm2List[1].val = val1[1]
      }
    },

    // 维护环境标准configData
    sumbitEditRow(formName) {
      var that = this
      for(var i=0;i<this.configList.length;i++){
        if(i==0){
          this.configData.pm2 = this.configList[i].val
        }else if(i==1){
          this.configData.pm10 = this.configList[i].val
        }else if(i==2){
          this.configData.noise = this.configList[i].val
        }else if(i==3){
          this.configData.temperature = this.configList[i].val
        }else if(i==4){
          this.configData.humidity = this.configList[i].val
        }else if(i==5){
          this.configData.windSpeed = this.configList[i].val
        }
      }
      this.configData.pm25 = this.pm2List[0].val+','+this.pm2List[1].val
      delete this.configData.createDate
      delete this.configData.updateDate
      this.configData.projectId = this.groupId
      if(this.hasConf){
        this.configData.updateBy = util.session.get('user').id
        myHttp.updateDustConfig(this.configData).then(function(resp){
          if(resp.data.code=='200'){
            that.$message.success('配置成功')
            that.editFormVisible = false
            that.pm2FormVisible = false
          }else{
            that.$message.error(resp.data.msg)
          }
        })
      }else{
        this.configData.createBy = util.session.get('user').id
        myHttp.addDustConfig(this.configData).then(function(resp){
          if(resp.data.code=='200'){
            that.$message.success('配置成功')
            that.editFormVisible = false
            that.pm2FormVisible = false
          }else{
            that.$message.error(resp.data.msg)
          }
        })
      }
    },
    //设置默认值
    setDetfaule(){
      for(var i=0;i<this.configList.length;i++){
          this.configList[i].val = this.configList[i].default
      }
    },

    //打开pm2.5优良差
    setPm2(){
      this.pm2FormVisible = true
      var that = this
      myHttp.selectDustConfig({
        projectId:util.session.get('groupId')
      }).then(function(resp){
        if(resp.data.code=='200'){
          var data = resp.data.data.list
          if(data){
            that.hasConf = true
            that.configData = data
            that.setConfigList(data)
          }else{
            that.hasConf = false
          }
        }else{
          that.$message.error(resp.data.msg)
        }
      })
    },
    //设置pm2.5默认
    setDetfaulePm2(){
      for(var i=0;i<this.pm2List.length;i++){
        this.pm2List[i].val = this.pm2List[i].default
      }
      
    },

    //进入预警记录信息页面
    goWarn(){
      this.$router.push({path:'/dustWarn'})
    },

    /**
     * 切换设备
     */
    changeDevice(row){
      if(row.id != this.dustId){
        this.dustId = row.id
        this.getData()
        this.getDataLine()
        this.getProjectInfo()
      }
    },

    /**
     * 获取天气
     */
    getProjectById(){
        var that = this
        myHttp.getProjectById({
            id: this.groupId
        }).then(function(resp) {
            if (resp.data.code == '200') {
                var data = resp.data.data.project
                that.setAreaFun(data.areaId)
            }
        })
    },
    //获取省市区
    setAreaFun(id){
      if ('' == id || undefined == id) {
          this.getWeather()
          return
      }
      var that = this
      myHttp.getAreaById({
          id: id
      }).then(function(resp) {
          var proCity = ''
          if (resp.data.code == '200') {
              var city = resp.data.data.area.cityName
              var area = resp.data.data.area.name
              proCity = city.indexOf('市')>0?city:area
              
          }
          that.getWeather(proCity)
      },function(error) {})
    },
    //获取天气
    getWeather(city){
      var that = this;
      city = city?city:'合肥市'
      myHttp.getWeather({
          city:city
      }).then(function(resp){
          if(resp.data.code=='200'){
              var info = resp.data.data.data
              that.weather.now1 = that.getSkyIcon(info.forecast[0].type);
              that.weather.now2 = info.forecast[0].low.split(' ')[1] + '~' + info.forecast[0].high.split(' ')[1];
              that.weather.now3 = info.forecast[0].type;
              that.weather.tomorrow = that.getSkyIcon(info.forecast[1].type);
              that.weather.after1 = that.getSkyIcon(info.forecast[2].type);
              that.weather.after2 = that.getSkyIcon(info.forecast[3].type);
              that.valData[2].val2 = info.forecast[0].fengxiang
          }
      })
    },
    getSkyIcon(type){
      if(type=='多云'){
          return require('../../assets/image/weather/w1.png');
      }else if(type=='晴天'){
          return require('../../assets/image/weather/w0.png');
      }else if(type=='阴'){
          return require('../../assets/image/weather/w2.png');
      }else if(type.indexOf("雷阵雨")>-1){
          return require('../../assets/image/weather/w4.png');
      }else if(type.indexOf("阵雨")>-1){
          return require('../../assets/image/weather/w3.png');
      }else if(type.indexOf("雨")>-1){
          return require('../../assets/image/weather/w5.png');
      }else if(type.indexOf("雪")>-1){
          return require('../../assets/image/weather/w6.png');
      }else{
          return require('../../assets/image/weather/w1.png');
      }
    },

     initCharts1 () {
        let data = [
          {
            value: this.dust.alarmDust,
            name: '报警设备'
          },
          {
            value: this.dust.offlineDust,
            name: '离线设备'
          },
          {
            value: this.dust.onlineDust,
            name: '在线设备'
          }
        ]
        this.myChart1.setOption({
          title: {
            show: true,
            text: '设备总数',
            subtext: this.dustTotal,
            top: 'center',
            left: 'center',
            textStyle: {
              fontSize: 18
            },
            subtextStyle: {
              fontSize: 18,
              color: '#0765FF'
            }
          },
          legend: {
            orient: 'vertical',
            right: '0',
            top: 'center',
            data: ['报警设备', '离线设备', '在线设备'],
          },
          series: [
            {
              type: 'pie',
              radius: ['50%', '70%'],
              avoidLabelOverlap: false,
              label: {
                show: false,
                position: 'center',
              },
              labelLine: {
                show: false,
              },
              data: data,
              color: ['#D81E06', '#CCCCCC', '#0263FF'],
              itemStyle: {
                emphasis: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: 'rgba(0, 0, 0, 0.5)',
                },
              },
            },
          ],
           
        });
       window.addEventListener("resize", () => {
          this.myChart1.resize();
        });
    },
    initCharts2 () {
        let that = this
        this.myChart2.setOption({
          tooltip: {},
          xAxis: {
            data: ["PM2.5","PM10","TSP","温度","湿度","噪音","风速","气压"]
          },
          yAxis: {
            type: 'value'
          },
          grid: {
            bottom: '40vh',
            right: '18vw'
          },
          series: [
            {
              type: 'bar',
              data: this.newValData,
              barWidth: 20,
              label: {
                show: true,
                position: 'top'
              },
              barGap: '50%',
              itemStyle: {
                normal: {
                  barBorderRadius: [20,20,0,0],
                  color: function(data){
                    let color = []
                    if(data.name == 'PM2.5'){
                      if(data.value > that.normalDate.pm2) {
                        color[0] = '#ff0000'
                      }else{
                        color[0] = '#1668f0'
                      }
                    }
                    if(data.name == 'PM10'){
                      if(data.value > that.normalDate.pm10) {
                        color[1] = '#ff0000'
                      }else{
                        color[1] =  '#1668f0'
                      }
                    }
                    if(data.name == '温度'){
                      if(data.value > that.normalDate.temperature) {
                        color[3] = '#ff0000'
                      }else{
                        color[3] =  '#1668f0'
                      }
                    }
                    if(data.name == '湿度'){
                      if(data.value > that.normalDate.humidity) {
                        color[4] = '#ff0000'
                      }else{
                        color[4] =  '#1668f0'
                      }
                    }
                    if(data.name == '噪音'){
                       if(data.value > that.normalDate.noise) {
                          color[5] = '#ff0000'
                        }else{
                          color[5] =  '#1668f0'
                        }
                    }
                    if(data.name == '风速'){
                      if(data.value > that.normalDate.windSpeed) {
                        color[6] = '#ff0000'
                      }else{
                        color[6] =  '#1668f0'
                      }
                    }
                    color[2] = '#1668f0'
                    color[7] = '#1668f0'
                    return color[data.dataIndex]
                  }
                }
              }
            }
          ],
        });
         window.addEventListener("resize", () => {
          this.myChart2.resize();
        });
    }
    

  },
  destroyed(){
    if(this.timeOutFun){
      window.clearTimeout(this.timeOutFun)
    }
  },
}
</script>

<style scoped>
.content >>> .el-card__body {
  padding: 0 !important;
  height: 100% !important;
}
.grid-content {
  height: 2.5vh;
  font-size: 1.6vh;
}
.aside {
  box-shadow: rgba(8, 42, 51, 0.1) 0px 0px 7px 0px !important;
  border-radius: 10px !important;
  border: 0px !important;
  background-color: rgb(255, 255, 255);
  display: flex;
  flex-direction: column;
}
.search-section {
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  margin: 20px 35px 20px -12px;
  height: 40px;
  justify-content: space-between;
}
.grid-content1 {
  /* height: 2.5vh; */
  font-size: 1.6vh;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-right: 4px;
}
.page5 {
  overflow: hidden;
  height: 100%;
}

.page5 .el-row:nth-child(1) .el-col .el-card{
  height:270px;
}
.page5 .el-row:nth-child(2) .el-col .el-card{
  height: 480px;
}

/* .page5 .el-row:last-child {
  margin-bottom: 30px;
} */

.el-col {
  margin-top: 20px;
  border-radius: 4px;
}

.text {
  font-size: 16px;
}

.item {
  padding: 18px 0;
  position: absolute;
  left: 18px;
  top: -10px;
}

.box-card {
  position: relative;
  padding: 10px;
}

.time-up {
  width: 95%;
  display: flex;
  justify-content: space-between;
}

.month-pie,
.month-cir {
  position: absolute;
  /* top: 15px; */
  left: 20px;
  font-size: 18px;
  /* font-weight: bold; */
  color: #707070;
}

.page5 .month-pie span .link-date {
  margin-left: 50px;
  font-size: 15px;
}

/* 年份 */

.year-width {
  width: 80px;
}

.month-cir >>> .el-input__inner {
  border: 0 none;
  height: auto;
  line-height: 20px;
  font-size: 18px;
  padding: 0;
}

.month-cir >>> .el-input__suffix {
  right: 12px;
}

.month-cir >>> .el-input--suffix .el-input__inner {
  padding-right: 0;
  height: auto;
}

.month-cir >>> .el-select .el-input__inner {
  padding-right: 0;
}

.month-cir >>> .el-input__icon {
  height: auto;
  line-height: 20px;
}

/* 月份 */

.month-width {
  position: absolute;
  top: 15px;
  left: 20px;
  width: 60px;
  font-size: 18px;
  font-weight: bold;
  color: #707070;
}

.month-width >>> .el-input__inner {
  border: 0 none;
  height: auto;
  line-height: 20px;
  font-size: 18px;
  padding: 0;
}

.month-width >>> .el-input__suffix {
  right: 12px;
}

.month-width >>> .el-input--suffix .el-input__inner {
  padding-right: 0;
  height: auto;
}

.month-width >>> .el-select .el-input__inner {
  padding-right: 0;
}

.month-width >>> .el-input__icon {
  height: auto;
  line-height: 20px;
}

.page5-cir2 {
  left: 108px;
}

.card-con {
  height: 70px;
  display: flex;
  align-content: center;
  align-items: center;
  justify-content: center;
}

.card-num {
  width: 60%;
  padding: 18px;
}

.card-num span {
  font-size: 30px;
  color: #1b3bf5;
  font-weight: bold;
}

.card-num img {
  top: -7px;
  position: relative;
}

.color1 span {
  color: #4ecbff;
}

.color2 span {
  color: #ffbc01;
}

.bg-purple {
  position: relative;
  top: 25px;
  left: -3px;
  margin: auto;
  width: 344px;
  height: 280px;
}

.monitor {
  margin-bottom: 44px;
  font-size: 15px;
  text-align: left;
  color: #707070;
}

/* .monitor-abr {
  margin-top: -8px;
} */

.monitor-bar1 {
  position: relative;
  width: 100%;
  height: 16px;
  background: #d2cccc;
  overflow: hidden;
  border-radius: 30px;
}

.monitor-bar1 .ul1 {
  display: block;
  width: 100%;
  height: 20px;
}

.monitor-bar1 .ul1 li {
  width: 33.33%;
  height: 20px;
  float: left;
}

.monitor-bar1 .ul2 li {
  width: 33.3333%;
  height: 20px;
  float: left;
}

.abr-num,
.abr2-num {
  position: relative;
  bottom: -10px;
}

.abr-num li,
.abr2-num li {
  float: left;
  text-align: center;
}

.abr-num li:nth-child(2) {
  margin-left: 55px;
}

.abr-num li:nth-child(3) {
  margin-left: 53px;
}

.abr-num li:nth-child(4) {
  margin-left: 48px;
}

.abr-num li:nth-child(5) {
  margin-left: 48px;
}

.abr-num li:nth-child(6) {
  position: relative;
  right: -47px;
}

.abr-num li span,
.abr2-num li span {
  color: #1b3bf5;
  font-size: 12px;
}

.abr-num li p,
.abr2-num li p {
  color: #707070;
  font-size: 12px;
}

.abr2-num li:nth-child(2) {
  margin-left: 101px;
}

.abr2-num li:nth-child(3) {
  margin-left: 98px;
}

.abr2-num li:nth-child(4) {
  position: relative;
  right: -92px;
}

.monitor-box,
.monitor-box2 {
  position: absolute;
  /* left: -20px; */
  /* width: 46px;
  height: 46px;
  line-height: 55px;
  font-size: 13px;
  text-align: center;
  color: #1b3bf5;
  background: url(../../assets/image/water.png) no-repeat;
  background-size: cover; */
  width: 0;
  height: 0;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-bottom: 20px solid red;
}

/* 1.14X32 */

/* box1 200 */
.monitor-box {
  position: absolute;
  /* left: 73.5%; */
}

/* box1 300, box2 150 */
.monitor-box,
.monitor-box2 {
  position: absolute;
  /* left: 320px; */
}

.page5-tu2 {
  margin-top: 15px;
}

.page5-tu4 {
  margin-top: 5px;
  margin-left: -85px;
}
.build-bar .btnLef {
  position: absolute;
  right: 6%;
  display: block;
  width: 95px;
  height: 40px;
  line-height: 40px;
  color: #fff;
  border-radius: 4px;
  background: #ffaf15;
  border: 1px solid #ffb800;
}

.main-left{
    width: 10vw;
    height: 100%;
    position: relative;
    padding: 1vh 0.6vh;
    display: flex;
    flex-wrap: wrap;
    overflow: auto;
    background: #fff;
    align-content: flex-start;
}
.main-left-item{
    height: 7vh;
    width: 100%;
    position: relative;
    background: #E7F1FB;
    display: flex;
    flex-wrap: wrap;
    align-content: center;
    align-items: center;
    padding: 0.5vh;
    cursor: pointer;
    margin-top: 1vh;
}
.main-left-item p{
    height: 3vh;
    position: relative;
    text-align: left;
    display: flex;
    align-content: center;
    align-items: center;
}
.main-left-item .name{
    width: calc( 100% - 3vw );
    position: relative;
}
.main-left-item .state{
    width: 3vw;
    position: relative;
    justify-content: flex-end;
}
.main-left-item .num{
    width: 100%;
    position: relative;
}
.curTower{
    background: #1E369A;
}
.curTower .name,.curTower .state,.curTower .num{
    color: #fff;
}
</style>
<style>
  @import '../../assets/css/common.css';
  .tower-dig .el-dialog__title{
      color: #0085FF;
    }
    .tower-dig .el-dialog__body,.tower-dig .el-dialog__footer{
      border-top: 1px solid #ddd;
    }
    .tower-dig span{
      font-weight: bold;
    }
    .tower-dig .el-dialog__header{
      text-align: left;
    }
    .config-con{
      display:flex;
      flex-wrap:wrap;
      width:100%;
      height:auto;
    }
    .config-con-item{
      width:100%;
      padding:1vh 0;
      display:flex;
      justify-content: space-around;
      align-items: center;
      align-content: center;
    }
</style>
<style scoped>
.circle{
  display: block;
  width: 1.5vh;
  height: 1.5vh;
  border-radius: 50%;
  background-color: #0B62F0;
  margin-right: 1vw;
}
.main-top{
  height: 37vh;
  width: 100%;
  margin-bottom: 1vh;
  display: flex;
  justify-content: space-between;
}
.section-left{
  position: relative;
  width: 20%;
  padding: 1vh 1vw;
  background: #fff;
  border-radius: 10px;
}
.weather-date{
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.weather{
  width: 100%;
  height: 25vh;
  display: flex;
  justify-content: center;
  align-items: center;
}
.temperature{
  position: absolute;
  padding: 0 1vw;
  bottom: 1vh;
  display: flex;
  width: 90%;
  justify-content: space-between;
  align-items: center;
}

.section-center{
  position: relative;
  padding: 1vh 1vw;
  width: 53%;
  border-radius: 10px;
  background-color: #fff;
}
.equipmet-top{
  display: flex;
  width: 100%;
  justify-content: space-between;
}
.equipmet-body{
  display: flex;
}
.equipmet-left{
  width: 40%;
  display: flex;
  flex-wrap: wrap;
  align-content: center;
}
.equipmet-item{
  width: 35%;
  height: 8vh;
  background-color: #E7E7E7;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  border: 1px solid #ccc;
  margin-right: 1vw;
  margin-bottom: 2vh;
}
.equipmet-right{
  width: 65%;
  height: 30vh;
}
.section-right{
  position: relative;
  width: 25%;
  padding: 1vh 1vw;
  border-radius: 10px;
  background-color: #fff;
}

.main-bottom{
  position: relative;
  height: calc(100% - 38vh);
  width: 100%;
  padding: 2vh 1vw;
  background-color: #fff;
  border-radius: 10px;
  display: flex;
}
.monitor-left{
  width: 90%;
  height: 100%;
}
.monitor-right{
  width: 10%;
  height: 100%;
  position: relative;
}
.monitor-item{
  width: 7vw;
  text-align: left;
  margin-top: 2vh;
}
</style>